module.exports = __webpack_public_path__ + "img/vncLogo.d8031398.png";